import { v4 as uuid } from 'uuid';
import jwtDecode from 'jwt-decode';
import queryString from 'query-string';
import {
  appStorage, firstSuccessfulPromise, logError, parseQueryString
} from './utils';
import { appId } from '../config.json';
import { getJwtToken } from './call-my-jio';
import config from '../config.json';

const storageKeys = {
  sourceId: 'covid_source_id',
  businessId: 'covid_business_id',
  userId: 'covid_user_id',
  euserId: 'covid_euser_id',
  sourceUserId: 'covid_source_user_id',
  userContactNumber: 'user_contact_number',
  displayType: 'display_type',
  workflowId: 'workflow_id'
};

const getSourceFromQueryString = () => {
  const parsed = queryString.parse(window.location.search);
  return {
    sourceId: parsed.source_id,
    displayType: parsed.display_type,
    businessId: decodeURIComponent(parsed.business_id || ''),
    sourceUserId: decodeURIComponent(parsed.device_jio_id || parsed.source_user_id || ''),
    workflowId: parsed.workflow_id
  };
};

const getSourceFromStorage = () => ({
  displayType: appStorage.getItem(storageKeys.displayType),
  sourceId: appStorage.getItem(storageKeys.sourceId),
  businessId: appStorage.getItem(storageKeys.businessId),
  userId: appStorage.getItem(storageKeys.userId),
  euserId: appStorage.getItem(storageKeys.euserId),
  sourceUserId: appStorage.getItem(storageKeys.sourceUserId),
  userContactNumber: appStorage.getItem(storageKeys.userContactNumber),
  workflowId: appStorage.getItem(storageKeys.workflowId)
});

const getSourceFromMyJio = async () => {
  try {
    let jwtToken = await getJwtToken();
    if (!jwtToken) {
      jwtToken = parseQueryString().jwt;
    }
    if (jwtToken) {
      const decoded = jwtDecode(jwtToken);
      return {
        userId: (decoded.customerId || `mobile_${decoded.phoneNo}`),
        euserId: decoded.paramcd,
        sourceId: 'MyJioApp',
        userContactNumber: decoded.phoneNo
      };
    }
  } catch (e) {
    logError(e);
  }
  return {};
};

export default async () => {
  const source = await firstSuccessfulPromise(
    [getSourceFromQueryString, getSourceFromStorage, getSourceFromMyJio],
    source => Object.values(source).find(value => Boolean(value)),
    {}
  );
  const userId = source.userId || uuid();
  const { euserId = '' } = source;
  const sourceId = source.sourceId || appId;
  const sourceUserId = source.sourceUserId || userId;
  const businessId = source.businessId || null;
  const displayType = source.displayType || 'chat';
  const workflowId = source.workflowId;
  const { userContactNumber } = source;

  userId && appStorage.setItem(storageKeys.userId, userId);
  euserId && appStorage.setItem(storageKeys.euserId, euserId);
  sourceId && appStorage.setItem(storageKeys.sourceId, sourceId);
  sourceUserId && appStorage.setItem(storageKeys.sourceUserId, sourceUserId);
  userContactNumber && appStorage.setItem(storageKeys.userContactNumber, userContactNumber);
  businessId && appStorage.setItem(storageKeys.businessId, businessId);
  displayType && appStorage.setItem(storageKeys.displayType, displayType);
  workflowId && appStorage.setItem(storageKeys.workflowId, workflowId);
  return {
    user_id: userId,
    e_user_id: euserId,
    source_id: sourceId,
    source_user_id: sourceUserId,
    business_id: businessId,
    user_contact_number: userContactNumber,
    display_type: displayType,
    workflow_id: workflowId,
  };
};
